import React from 'react';
import { withRouter } from 'react-router';
import { NormalText, Subtitle } from '../common';
import { withTranslation } from '../../lib/translate';
import './index.css';

const BlockSeparator = (props) => {
  const { __, text, fullWidth } = props;
  return (
    <div className={`block-separator ${fullWidth ? 'block-separator-full' : ''}`}>
      <div className="separator-line"></div>
      {!fullWidth &&
      <>
        <NormalText>{__(text ? text : 'or')}</NormalText>
        <div className="separator-line"></div>
      </>
    
      }
    </div>
  );
};

export default withRouter(withTranslation(BlockSeparator));
